import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { toast } from "react-toastify"
import CustomTextField from "../CustomTextField";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { es } from "date-fns/locale";
import { Controller } from "react-hook-form";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { DialogTitle, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { MuiFileInput } from "mui-file-input";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerLocalidades,
  obtenerPaises,
  obtenerProvincias,
} from "../../Redux/autocompletados";
import { cargarAdjuntoSolicitud, solucitudActualizacionDomicilio } from "../../Redux/solicitudes";
import { UserAuth } from "../../context/AuthContext";
import TokenContext from "../../context/TokenContext";
import CustomSearchSelect from "../CustomSearchSelect";
import CustomDateField from "../CustomDateField";

const ModalSolicitudDomicilio = ({ open, handleClose }) => {
  const token = useContext(TokenContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { empleado } = UserAuth();

  const paisesSelector = useSelector((store) => store.autocompletados.paises);
  const provinciasSelector = useSelector((store) => store.autocompletados.provincias);
  const estadoSolicitudDomicilio = useSelector((store) => store.solicitudes.estadoSolicitudDomicilio);
  const loadingLocalidades = useSelector((store) => store.autocompletados.loadingLocalidades);

  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [paises, setPaises] = React.useState([]);
  const [provincias, setProvincias] = React.useState([]);
  const [localidades, setLocalidades] = React.useState([]);

  useEffect(() => {
    if (token) {
      dispatch(obtenerPaises(token));
      dispatch(obtenerProvincias(token));
      dispatch(obtenerLocalidades(token));
    }
  }, []);

  useEffect(() => {
    if (paisesSelector?.length > 0) {
      const paises = [];
      paisesSelector.forEach((item) => {
        const object = {
          value: item.new_paisid,
          label: item.new_name,
        };
        paises.push(object);
      });
      setPaises(paises);
    }
  }, [paisesSelector]);

  useEffect(() => {
    if (provinciasSelector?.length > 0) {
      const provincias = [];
      provinciasSelector.forEach((item) => {
        const object = {
          value: item.new_provinciaid,
          label: item.new_name,
        };
        provincias.push(object);
      });
      setProvincias(provincias);
    }
  }, [provinciasSelector])

  useEffect(() => {
    if (loadingLocalidades?.length > 0) {
      const provincias = [];
      loadingLocalidades.forEach((item) => {
        const object = {
          value: item.new_localidadid,
          label: item.new_name,
        };
        provincias.push(object);
      });
      setLocalidades(provincias);
    }
  }, [loadingLocalidades])
  

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile);
  };

  const defaultValues = {
    empleado: empleado.empleadoid,
    asunto: "",
    fechaSolicitud: "",
    fechaVigencia: "",
    calle: "",
    nro: null,
    depto: "",
    piso: null,
    barrio: "",
    localidad: "",
    codigoPostal: "",
    provincia: null,
    pais: null,
  };

  const validacionSchema = yup.object().shape({
    asunto: yup.string().required("Por favor indica el asunto."),
    fechaSolicitud: yup.string().required("Required"),
    fechaVigencia: yup.string().required("Required"),
    calle: yup.string().required("Por favor indica la calle."),
    codigoPostal: yup.string().required("Por favor indica tu código postal."),
    localidad: yup.object({
      value: yup.string().required("Por favor indica la localidad"),
    }),
    provincia: yup.object({
      value: yup.string().required("Por favor indica la provincia"),
    }),
    pais: yup.object({
      value: yup.string().required("Por favor indica el país"),
    }),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { handleSubmit, trigger, watch } = methods;

  const aprobarValue = watch(defaultValues);

  console.log(aprobarValue);

  const submitDatos = (datos) => {

    const formData = new FormData()
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        setSelectedFiles([])
        return
      }
      let element = selectedFiles[index]
      formData.append(`body${index}`, element)
    }
    dispatch(solucitudActualizacionDomicilio(token, datos))
      .then((id) => {
        handleClose()
        if(selectedFiles.length > 0 && id.length > 0){
          dispatch(cargarAdjuntoSolicitud(token, formData, id, 'cambioDomicilio_id'))
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="asunto"
                label="Asunto"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el asunto."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaSolicitud"
                label="Fecha solicitud:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de solicitud"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomDateField
                name="fechaVigencia"
                label="Fecha a partir de vigencia:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de vigencia"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="calle"
                label="Calle"
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="number"
                name="nro"
                label="Nro"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="depto"
                label="Departamento"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="number"
                name="piso"
                label="Piso"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="barrio"
                label="Barrio"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={localidades}
                req="true"
                type="text"
                name="localidad"
                lab="Localidad"
                helperText="Por favor indica la Localidad."
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="codigoPostal"
                label="Codigo Postal"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el codigo postal."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={provincias}
                req="true"
                type="text"
                name="provincia"
                lab="Provincia"
                helperText="Por favor indica la provincia."
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={paises}
                req="true"
                type="text"
                name="pais"
                lab="País"
                helperText="Por favor indica el país."
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput
                value={selectedFiles}
                multiple
                label="Adjuntar documento"
                onChange={changeHandler}
                fullWidth
              />
            </Grid>
            <Grid sx={{ px: 2, mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>
                    El tamaño máximo permitido por archivo es de 15 MB
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={estadoSolicitudDomicilio === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ModalSolicitudDomicilio;
